// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JgLT","placeholdersHeader":"styles_placeholdersHeader__386lj","editorStyle":"styles_editorStyle__2KCh4","placeholdersBox":"styles_placeholdersBox__1JnNJ"};